import { CurrencyPipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ProductType } from 'src/app/Enums/productType';
import { CompanyAddressList } from 'src/app/models/companyAddress/company-address-model';
import { AddProductModel, SearchTagsArrayList, SearchTagsModel, UpdateProductModel } from 'src/app/models/product/addProduct.model';
import { ProductList } from 'src/app/models/product/productListing.modal';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { ProductService } from 'src/app/services/product.service';
import { environment } from '../../../../../../../environments/environment';

@Component({
  selector: 'app-upadate-product',
  templateUrl: './upadate-product.component.html',
  styleUrls: ['./upadate-product.component.css']
})
export class UpadateProductComponent implements OnInit {
  Updateproduct: AddProductModel;
  getProductdetails: ProductList;
  selectedActiveValue: boolean;
  selectedJustAddedValue: boolean;
  selectedSaleValue: boolean;
  selectedQuoteValue: boolean;
  productId: string;
  productSub: Subscription;
  tinyMCEkey: string;
  Loader: boolean = false;
  selectedDiscountValue: string;
  selectedShippingRequired: string;
  getCategories: [];
  selectedCategory: [];
  selectedCompany: [];
  companyAddressListing: [];
  selectedCompanyAddress: any;
  selectedCategories: any;
  searchTags: any;
  featureEditorElement: '';
  updateProductModel: UpdateProductModel;
  productType: Array<string>;
  discountShow: boolean = false;
  selectedActive: string;
  selectedJustAdded: string;
  selectedSale: string;
  selectedQuote: string;
  selectedProductType: number;
  formattedAmount;
  searchTagsListing: SearchTagsModel;
  searchTagsResponseModel: SearchTagsArrayList = new SearchTagsArrayList();
  selectedSearchTag: [];
  selectedAccessories: string;

  constructor(private currencyPipe : CurrencyPipe, private localstorage: LocalstorageService, private _productService: ProductService, private alertify: AlertifyService, private modalService: NgbModal, private router: ActivatedRoute, private route: Router) {
    this.localstorage.setMenu("5");
    this.Updateproduct = new AddProductModel();
    this.getProductdetails = new ProductList();
    this.searchTagsListing = new SearchTagsModel();
  }

  ngOnInit() {
    this.tinyMCEkey = environment.tinyMCEKey;
    this.router.params.subscribe((param) => {
      this.productId = param.id;
    })
    var productTypeEnum = new Array<string>();  
    Object.values(ProductType).map(function(key){       
      if (typeof(key) == 'string') {
        productTypeEnum.push(key);
      }  
    });
    this.productType = productTypeEnum;
    this.getAllCategories();
    this.updateCompanyAddress();
    this.updateSearchTags();
  }
  transformAmount() {
    var ele = document.getElementById('productPrice') as HTMLButtonElement | null;
    ele.value = this.currencyPipe.transform(ele.value, '$');
    
  }

  getAllCategories() {
    this._productService.getCategories().subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.getCategories = responseBody.responseData;
        this.getProductById();
      }
    });
  }

  selectDiscountActive(selectedValue) {
    this.selectedDiscountValue = selectedValue;
    if(this.selectedDiscountValue == "1") {
      this.discountShow = true;
    } else {
      this.discountShow = false;
    }
    this.Updateproduct.IsShowDiscount = this.selectedDiscountValue;
  }

  getSelectedCategory(selectedValue) {
    this.selectedCategory = selectedValue;
    this.Updateproduct.CategoryIds = this.selectedCategory.toString();
  }

  selectedAddress(selectedValue) {
    this.selectedCompany = selectedValue;
    this.Updateproduct.CompanyAddressId = this.selectedCompany.toString();
  }
  selectShippingRequired(selectedValue) {
    this.selectedShippingRequired = selectedValue;
  }

  onCancel() {
    this.modalService.dismissAll();
  }

  selectJustAdded(selectedValue) {
    this.selectedJustAdded = selectedValue;
  }

  selectSale(selectedValue) {
    this.selectedSale = selectedValue;
  }

  selectAccessories(selectedValue) {
    this.selectedAccessories = selectedValue;
  }

  selectQuote(selectedValue) {
    this.selectedQuote = selectedValue;
  }

  selectProductType(selectedValue) {
    this.selectedProductType = selectedValue;
    this.Updateproduct.ProductType = this.selectedProductType;
  }

  selectActive(selectedValue) {
    this.selectedActiveValue = selectedValue;
  }

  selectActiveProduct(selectedProductValue) {
    this.selectedActive = selectedProductValue;
  }
   
  getSearchTags(selectedValue) {
    if (typeof(selectedValue) === 'object' && selectedValue !== null) {
      for (var i = 0; i < selectedValue.length; i++) {
        if (typeof(selectedValue[i]) === 'object') {
          if ('label' in selectedValue[i]) {
            selectedValue[i] = selectedValue[i].label;
          } else {            
            selectedValue[i] = selectedValue[i].$ngOptionLabel;
          }
        }
      }
    }
    this.selectedSearchTag = selectedValue;
    this.Updateproduct.SearchTags = this.selectedSearchTag.toString();
  }

  showFeatureEditorValue() {
    var featureEditorElement: HTMLIFrameElement = document.getElementById('Features_ifr') as HTMLIFrameElement;
    featureEditorElement.contentWindow.document.getElementById('tinymce').innerHTML = this.getProductdetails.features;
    this.Updateproduct.Features = featureEditorElement.contentWindow.document.getElementById('tinymce').innerHTML;
  }

  showDescriptionEditorValue() {
    var descriptionEditorElement: HTMLIFrameElement = document.getElementById('Description_ifr') as HTMLIFrameElement;
    descriptionEditorElement.contentWindow.document.getElementById('tinymce').innerHTML = this.getProductdetails.description;
    this.Updateproduct.Description = descriptionEditorElement.contentWindow.document.getElementById('tinymce').innerHTML;
  }

  getProductById() {
    this.Loader = true;
    this._productService.getProductById(this.productId).subscribe((response) => {
      var responseBody = JSON.parse(response._body);
      this.getProductdetails = responseBody.responseData;
      this.Updateproduct.ProductName = this.getProductdetails.productName;
      this.Updateproduct.ProductTitle = this.getProductdetails.productTitle;
      this.Updateproduct.Length = this.getProductdetails.length;
      this.Updateproduct.Width = this.getProductdetails.width;
      this.Updateproduct.Height = this.getProductdetails.height;
      this.Updateproduct.Weight = this.getProductdetails.weight;
      this.Updateproduct.Price = this.getProductdetails.price;
      this.Updateproduct.CategoryIds = this.getProductdetails.categoryIds;
      this.Updateproduct.CategoryNames = this.getProductdetails.categoryNames;
      this.Updateproduct.CompanyAddressId = this.getProductdetails.companyAddressId;
      this.Updateproduct.Title = this.getProductdetails.title;
      this.Updateproduct.SearchTags = this.getProductdetails.searchTags;
      this.Updateproduct.ProductType = this.getProductdetails.productType;
      this.Updateproduct.IsActive = this.getProductdetails.isActiveValue; 
      this.selectedActive = this.Updateproduct.IsActive ? "1" : "0";
      this.Updateproduct.IsJustAdded = this.getProductdetails.isJustAddedValue; 
      this.selectedJustAdded = this.Updateproduct.IsJustAdded ? "1" : "0";   
      this.Updateproduct.IsSale = this.getProductdetails.isSaleValue; 
      this.selectedSale = this.Updateproduct.IsSale ? "1" : "0"; 
      this.Updateproduct.IsAccessories = this.getProductdetails.isAccessoriesValue; 
      this.selectedAccessories = this.Updateproduct.IsAccessories ? "1" : "0";  
      this.Updateproduct.IsQuote = this.getProductdetails.isQuoteValue; 
      this.selectedQuote = this.Updateproduct.IsQuote ? "1" : "0";  
      this.Updateproduct.IsShippingRequired = this.getProductdetails.isShippingRequiredValue; 
      this.selectedShippingRequired = this.Updateproduct.IsShippingRequired ? "1" : "0";  
      this.Updateproduct.IsShowDiscountValue = this.getProductdetails.isShowDiscountValue;
      this.Updateproduct.Discount = this.getProductdetails.discount;
      this.selectedDiscountValue = this.Updateproduct.IsShowDiscountValue ? "1" : "0"; 
      this.Updateproduct.GetSearchTags = this.getProductdetails.searchTags[0]?this.getProductdetails.searchTags.split(","):[];
      if(this.Updateproduct.IsShowDiscountValue == "1") {
        this.discountShow = true;
      } else {
        this.discountShow = false;
      }
      
      setTimeout(() => {
        this.showFeatureEditorValue();
        this.showDescriptionEditorValue();
        this.transformAmount();
      }, 700);
      this.Loader = false;
    });
  }
  onSubmit() {
    if (this.Updateproduct.ProductName == undefined || this.Updateproduct.ProductName == null || this.Updateproduct.ProductName == "") {
      this.alertify.error("Product Name is required");
      return;
    }
    if (this.Updateproduct.ProductTitle == undefined || this.Updateproduct.ProductTitle == null || this.Updateproduct.ProductTitle == "") {
      this.alertify.error("Product Title is required");
      return;
    }
    if (this.Updateproduct.Price == undefined || this.Updateproduct.Price == null) {
      this.alertify.error("Price is required");
      return;
    }

    var getfeatureEditorElement: HTMLIFrameElement = document.getElementById('Features_ifr') as HTMLIFrameElement
    this.Updateproduct.Features = getfeatureEditorElement.contentWindow.document.getElementById('tinymce').innerHTML;
    var getdescriptionEditorElement: HTMLIFrameElement = document.getElementById('Description_ifr') as HTMLIFrameElement
    this.Updateproduct.Description = getdescriptionEditorElement.contentWindow.document.getElementById('tinymce').innerHTML;
    this.Updateproduct.IsActive = this.selectedActive;
    this.Updateproduct.IsJustAdded = this.selectedJustAdded;
    this.Updateproduct.IsSale = this.selectedSale;
    this.Updateproduct.IsAccessories = this.selectedAccessories;
    this.Updateproduct.IsQuote = this.selectedQuote;
    this.Updateproduct.IsShippingRequired = this.selectedShippingRequired;
    this.Updateproduct.IsShowDiscount = this.selectedDiscountValue;
    this.Updateproduct.Id = this.productId;
    this.Updateproduct.ProductType = this.selectedProductType;
    this.Loader = true;
    this._productService.updateProduct(this.Updateproduct)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        if (responseBody.isSuccess) {
          this.Updateproduct = responseBody.responseData;
          this.alertify.success(responseBody.responseMessage);
          this.route.navigate(['productListing']);
        } else {
          this.alertify.error(responseBody.responseMessage);
        }
        this.Loader = false;
      });
  }

  updateCompanyAddress() {
    this._productService.getAllCompanyAddress()
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.companyAddressListing = responseBody.responseData;
        }
      });
  }

  updateSearchTags() {  
    this._productService.searchTagsListing(this.searchTagsListing).subscribe(response => {
      this.Loader = false;
      var searchTagsList = JSON.parse(response._body);
      if (searchTagsList.isSuccess) {
        this.searchTagsResponseModel.searchTagsAllList = searchTagsList.responseData;
      } (err) => {
        this.Loader = false;
      }
    });
}

}
